module.exports = __webpack_public_path__ + "img/katarina_bedrooms_26.d7879465.jpg";